import { OrderSourceIntegrationsModule } from '@/shared';

export default OrderSourceIntegrationsModule;
